import { QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import type { ReactNode } from 'react';
import { queryClient } from '../api/query-client';
import { AuthProvider } from '../features/auth/AuthContext';
import { useIsLargeUp } from '../lib/use-media-query';
import { lightTheme, pointerTheme } from '../styles/themeConfig';

export type ProvidersProps = {
  children: ReactNode;
};

/**
 * Theme (antd) wraps server state (TanStack Query) wraps session state, so a
 * 401 can clear both. `AntdApp` supplies the context that `message` and
 * `notification` need instead of the static APIs.
 */
export function Providers({ children }: ProvidersProps) {
  /*
    One theme, two control heights — HMS's density from `lg` up, the 44px
    WCAG 2.5.5 target below it, where a finger is the input device. Swapping
    the whole theme object here rather than threading a size prop is what
    keeps it to one decision instead of 85 call sites; see `pointerTheme`.
  */
  const isPointerWidth = useIsLargeUp();

  return (
    <ConfigProvider theme={isPointerWidth ? pointerTheme : lightTheme}>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>{children}</AuthProvider>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  );
}
